import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import css_248z from './nav-item-group.scss.js';
import '../../atoms/nav-item/index.js';
import '../../atoms/sub-nav-item/index.js';

class NavItemGroup extends s {
    constructor() {
        super(...arguments);
        this.linkHref = '';
        this.ariaLabel = '';
        this.isNoFollow = false;
        this.target = '';
        this.rtl = false;
        this.subItems = [];
    }
    renderSubItems() {
        var _a;
        return (_a = this.subItems) === null || _a === void 0 ? void 0 : _a.slice(0, 8).map(item => {
            if (item.isTitleOnly) {
                return $ `<nav-item title="${item.title}" .linkHref="${item.link}" .target="${this.target || '_self'}" .ariaLabel="${this.ariaLabel}" .isNoFollow="${this.isNoFollow}" ?rtl="${this.rtl}"></nav-item>`;
            }
            return $ `<sub-nav-item title="${item.title}" .linkHref="${this.linkHref}" .target="${this.target || '_self'}" .ariaLabel="${this.ariaLabel}" .isNoFollow="${this.isNoFollow}" url="${item.link}" ?rtl="${this.rtl}" ?isActive="${item.isActive}"></sub-nav-item>`;
        });
    }
    renderParentNavItem() {
        if (!this.title) {
            return w;
        }
        return $ `<nav-item title="${this.title}" .linkHref="${this.linkHref}" .target="${this.target || '_self'}" .ariaLabel="${this.ariaLabel}" .isNoFollow="${this.isNoFollow}" ?isRtl="${this.rtl}"></nav-item>`;
    }
    render() {
        return $ `<div class="nav-group">${this.renderParentNavItem()}<div class="${o({
            'sub-items': true,
            'no-parent': !this.title,
        })}">${this.renderSubItems()}</div></div>`;
    }
}
NavItemGroup.styles = css_248z;
__decorate([
    e({ type: String })
], NavItemGroup.prototype, "title", void 0);
__decorate([
    e()
], NavItemGroup.prototype, "linkHref", void 0);
__decorate([
    e()
], NavItemGroup.prototype, "ariaLabel", void 0);
__decorate([
    e()
], NavItemGroup.prototype, "linkIcon", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], NavItemGroup.prototype, "isNoFollow", void 0);
__decorate([
    e({ type: String, reflect: true })
], NavItemGroup.prototype, "target", void 0);
__decorate([
    e({ type: Boolean })
], NavItemGroup.prototype, "rtl", void 0);
__decorate([
    e({ type: Array })
], NavItemGroup.prototype, "subItems", void 0);
customElements.define('nav-item-group', NavItemGroup);

export { NavItemGroup };
